import { connect } from "react-redux";

import {
    combineMultipleFufWithTransferType,
    UploadedFileInfo,
    uploadFufFileAction,
} from "../../../../ActionCreators/FufUploadActionCreator";
import { CandyDispatch } from "../../../Store/CandyReduxTypes";
import { CustomFile } from "../../../../../Helpers/file";
import { FullFormState } from "../../../Store/FullFormState";
import { ServerErrorResponse } from "../../../../../../../Common/CandyApiClient/Types/DraftActions/FileProperties";

import { ICombineByTransfers } from "./Types";
import { UploadSection } from "./UploadSection";

const mapStateToProps = (state: FullFormState) => ({
    currentGfv: state.settings.gfv,
    modalSettings: state.modalState,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    getFileProperties: (file: CustomFile | undefined): Promise<UploadedFileInfo> => dispatch(uploadFufFileAction(file)),
    combineMultipleWithTransfer: (
        files: ICombineByTransfers[],
        abortSignal?: AbortSignal
    ): Promise<ServerErrorResponse | undefined> => dispatch(combineMultipleFufWithTransferType(files, abortSignal)),
    reload: async () =>
        dispatch(async (_, __, form): Promise<void> => {
            await form.reloadInner();
        }),
});

export const UploadSectionContainer = connect(mapStateToProps, mapDispatchToProps)(UploadSection);
